import React, { useState, useEffect } from "react";
import { Box, Card, Grid, Typography, Button, Paper, Tooltip, TableContainer, Divider, Modal, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme, alpha } from "@mui/material";

import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Close from '@mui/icons-material/Close';

import GlobalConfig from "../../../config/date/GlobalConfig";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import TableFilterRow from "../../../components/table/TableFilterRow";
import CustomPagination from "../../../components/table/CustomPagination";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import { exportToExcel } from "../../../components/ExportToExcel";
import CustomDatePicker from "../../../components/CustomDatePicker";
const SheetCuttingReport = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = useState(false);
    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [loadingData, setLoadingData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [open, setOpen] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);
    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
        // getFGStockReport();
    };

    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
        //getFGStockReport();
    };


    const getReportData = () => {
        const formattedFromMODate = dayjs(FromDate).format('DD-MMM-YYYY');
        const formattedFromMODate1 = dayjs(ToDate).format('DD-MMM-YYYY');


        let parameters = {
            p_companyid: localStorage.getItem('companyid'),
            p_frommodate: formattedFromMODate,
            p_tomodate: formattedFromMODate1
        };
        setLoading(true);
        callApi(API_ENDPOINTS.REPORT_GetreportProductionSheetCuttingDetails, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                // Update state with fetched data
                setLoadingData(data);
                setLoading(false);
            })
            .catch(error => {
                alert(error);
            });

    };

    useEffect(() => {
        // Fetch data when FromDate or ToDate changes
        getReportData();
    }, [FromDate, ToDate]); 


    const [filters, setFilters] = useState({
        pr_number: '',
        child_reel_number: '',
        item_code: '',
        gsm: '',
        width: '',
        length: '',
    });
    const filteredData = loadingData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const excelColumns = [
        { header: "SHEET CUTTING DATE", key: "date" },
        { header: "PO NO.", key: "po_no" },
        { header: "ROLL NO", key: "pr_number" },
        { header: "REEL NO", key: "cr_number" },
        { header: "QUALITY", key: "item_code" },
        { header: "GSM", key: "gsm" },
        { header: "REEL SIZE", key: "width" },
        { header: "CUT SHEET", key: "no_of_cuts" },
        { header: "REEL USED", key: "reelused" },
        { header: "SIZE A", key: "width" }, // width repeated
        { header: "SIZE B", key: "length" },
        { header: "NO OF SHEET", key: "no_of_sheets" },
        { header: "WEIGHT(KG)", key: "pallet_weight" },
        { header: "SHEETER NO.", key: "cutter_name" },
        { header: "SHIFT", key: "shift_code" },
        { header: "ITEM", key: "size" },
        { header: "OPERATOR NAME", key: "operator_name" },
        { header: "REMARKS", key: "winder_remarks" },
         { header: "GRADE", key: "grade" },
          { header: "REPULP QTY", key: "repulp_qty" },
       
    ];
    const dateColumnIndexes = [0]; // "BUNDLE PACKING DATE"

    const handleExportToExcel = () => {
        exportToExcel({
            data: filteredData,
            fileName: 'Sheet Cutting Production Detail Report.xlsx',
            sheetName: 'Sheet Cutting Details',
            columns: excelColumns,           // 🔁 Fixed name
            dateColumnIndexes,
        });

        // const formattedData = filteredData.map(row => ({
        //     "SHEET CUTTING DATE": row.date ? new Date(row.date) : "", // ensures proper Excel format
        //     "PO NO.": row.po_no,
        //     "ROLL NO": row.pr_number,
        //     "REEL NO": row.cr_number,
        //     "QUALITY": row.item_code,
        //     "GSM": row.gsm,
        //     "REEL SIZE": row.width,
        //     "CUT SHEET": row.no_of_cuts,
        //     "REEL USED": row.reelused,
        //     "SIZE A": row.width,
        //     "SIZE B": row.length,
        //     "NO OF SHEET": row.no_of_sheets,
        //     "WEIGHT(KG)": row.pallet_weight,
        //     "SHEETER NO.": row.cutter_name,
        //     "SHIFT": row.shift_code,
        //     "ITEM": row.size,
        //     "OPERATOR NAME": row.operator_name,
        //     "REMARKS": row.remarks,
        // }));


    };

    const HandleClose = () => {
        handleExportToExcel();
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData.length / recordsPerPage);

    const uniqueValues = {
        po_no: [...new Set(loadingData.map(row => row.po_no))],
        pr_number: [...new Set(loadingData.map(row => row.pr_number))],
        cr_number: [...new Set(loadingData.map(row => row.cr_number))],
        item_code: [...new Set(loadingData.map(row => row.item_code))],
        gsm: [...new Set(loadingData.map(row => row.gsm))],
        cutter_name: [...new Set(loadingData.map(row => row.cutter_name))],
        shift_code: [...new Set(loadingData.map(row => row.shift_code))],
        operator_name: [...new Set(loadingData.map(row => row.operator_name))],
        grade: [...new Set(loadingData.map(row => row.grade))],
    };


    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );


    const columns = ['date', 'po_no', 'pr_number', 'cr_number', 'item_code', 'gsm', 'width', 'no_of_cuts', 'reelused', 'width', 'length', 'no_of_sheets', 'pallet_weight', 'cutter_name', 'shift_code', 'size', 'operator_name',  'winder_remarks','grade', 'repulp_qty', ];

    const autoCompleteColumns = ['po_no', 'pr_number', 'cr_number', 'item_code', 'gsm', 'cutter_name', 'shift_code', 'operator_name', 'grade'];

    const totals = {
        pallet_weight: filteredData.reduce((sum, r) => sum + (parseFloat(r.pallet_weight) || 0), 0),
        no_of_sheets: filteredData.reduce((sum, r) => sum + (parseFloat(r.no_of_sheets) || 0), 0),
        repulp_qty: filteredData.reduce((sum, r) => sum + (parseFloat(r.repulp_qty) || 0), 0),
    };




    return (
        <>
            <Box display="flex" flexDirection={'column'}>
                <Box m='0px' display="flex" alignItems={'center'}>
                    <Box ml={1}>
                        <Typography variant="h4" color={colors.grey[100]} fontWeight="semi bold" >Sheet Cutting Production Detail Report</Typography>
                    </Box>

                    <Grid item mt="2px" ml="5px" mr="auto" justifyContent="center">
                        <IconButton onClick={() => { handleBackWinderMachineEntry() }}>
                            <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                        </IconButton>
                    </Grid>
                </Box>

                <Divider />
                <Box m='0px' display="flex" alignItems={'center'}>
                    <Grid ml={1} item lg={2} xs={4} xl={2}>
                        <CustomDatePicker
                            value={FromDate}
                            onChange={(date) => handleDateChange2(date)}
                            autoFocus={true}
                        />
                    </Grid>

                    <Grid item mt="2px" ml="10px" mr="10px">
                        <Typography fontWeight="bold">-</Typography>
                    </Grid>

                    <Grid item lg={2} xs={4} xl={2}>
                        <CustomDatePicker
                            value={ToDate}
                            onChange={(date) => handleDateChange1(date)}
                        />
                    </Grid>

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    <Grid item mt="2px" ml="0px" mr="auto">

                        <Tooltip title="Download Report" onClick={HandleClose}>
                            <IconButton >
                                <FileDownloadIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Box>
            </Box>

            <Divider />
            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>

                <CustomTableContainer colors={colors}>

                    <TableContainer >
                        {loading ? (
                            <SkeletonTableLoader rows={5} columns={11} />
                        ) : (
                            <Table stickyHeader size="small" sx={{ tableLayout: 'fixed' }}>
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>

                                        <TableCell sx={{ width: '160px' }}>SHEET CUTTING DATE</TableCell>
                                        <TableCell sx={{ width: '100px' }}>PO NO.</TableCell>
                                        <TableCell sx={{ width: '100px' }}>ROLL NO</TableCell>
                                        <TableCell sx={{ width: '100px' }}>REEL NO</TableCell>
                                        <TableCell sx={{ width: '100px' }}>QUALITY</TableCell>
                                        <TableCell sx={{ width: '80px' }}>GSM</TableCell>
                                        <TableCell sx={{ width: '100px' }}>REEL SIZE</TableCell>
                                        <TableCell sx={{ width: '100px' }}>CUT SHEET</TableCell>
                                        <TableCell sx={{ width: '100px' }}>REEL USED</TableCell>
                                        <TableCell sx={{ width: '80px' }}>SIZE A</TableCell>
                                        <TableCell sx={{ width: '80px' }}>SIZE B</TableCell>
                                        <TableCell sx={{ width: '120px' }}>NO OF SHEET</TableCell>
                                        <TableCell sx={{ width: '100px' }}>WEIGHT(KG)</TableCell>
                                        <TableCell sx={{ width: '120px' }}>SHEETER NO.</TableCell>
                                        <TableCell sx={{ width: '80px' }}>SHIFT</TableCell>
                                        <TableCell sx={{ width: '80px' }}>ITEM</TableCell>
                                        <TableCell sx={{ width: '130px' }}>OPERATOR NAME</TableCell>
                                        <TableCell sx={{ width: '100px' }}>REMARKS</TableCell>
                                        <TableCell sx={{ width: '100px' }}>GRADE</TableCell>
                                        <TableCell sx={{ width: '100px' }}>RE-PULP QTY</TableCell>
                                       
                                    </TableRow>

                                    <TableFilterRow
                                        columns={columns}
                                        filters={filters}
                                        handleFilterChange={handleFilterChange}
                                        uniqueValues={uniqueValues}
                                        autoCompleteColumns={autoCompleteColumns}
                                    />

                                </TableHead>
                                <TableBody>
                                    {currentRecords.map((row, index) => (
                                        <TableRow key={row.id} sx={{

                                            backgroundColor:
                                                index % 2 === 0
                                                    ? theme.palette.background.default
                                                    : alpha(theme.palette.action.hover, 0.04), // slightly darker
                                        }}>


                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>{row.po_no}</TableCell>
                                            <TableCell>{row.pr_number}</TableCell>
                                            <TableCell>{row.cr_number}</TableCell>
                                            <TableCell>{row.item_code}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.gsm}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.width}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.no_of_cuts}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.reelused}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.width}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.length}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.no_of_sheets}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.pallet_weight}</TableCell>
                                            <TableCell>{row.cutter_name}</TableCell>
                                            <TableCell>{row.shift_code}</TableCell>
                                            <TableCell>{row.size}</TableCell>
                                            <TableCell>{row.operator_name}</TableCell>
                                            <TableCell>{row.winder_remarks}</TableCell>
                                            <TableCell>{row.grade}</TableCell>
                                            <TableCell sx={{ textAlign: 'right' }}>{row.repulp_qty}</TableCell>
                               
                                        </TableRow>
                                    ))}

                                    <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                        <TableCell colSpan={11} sx={{ fontWeight: 'bold', textAlign: 'right' }}>TOTAL </TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.no_of_sheets}</TableCell>
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.pallet_weight.toFixed(2)}</TableCell>
                                        <TableCell /> {/* SIZE1 */}
                                        <TableCell /> {/* SIZE2 */}
                                        <TableCell /> {/* REPULP /HOLD */}
                                        <TableCell /> {/* REMARKS */}

                                        <TableCell /> {/* GRADE */}
                                                    <TableCell /> {/* GRADE */}
                                        <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.repulp_qty.toFixed(2)}</TableCell>
                                          
                                    </TableRow>
                                </TableBody>


                            </Table>)}
                    </TableContainer>


                </CustomTableContainer>

            </ResponsiveBox>

            <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />

        </>
    )
};
export default SheetCuttingReport;